import React from 'react';
import SmallTitle from '../../../../components/SmallTitle';
import { SitemapSubItem } from '../SitemapSubItem';
import { ItemTitle } from './style';
import { Col } from 'reactstrap';

export const SitemapItem = props => {
  const {
    data: { label, mapLinks },
    subsection,
  } = props;
  return (
    <>
      <Col size="12" sm="4" className="mb-2">
        <ItemTitle className="feature_size">{label}</ItemTitle>
        {mapLinks.map(item => (
          <SitemapSubItem key={item.title} data={item} />
        ))}
        {subsection ? (
          <>
            <SmallTitle className="mt-sm-1">{subsection.subsectionText}</SmallTitle>
            {subsection.mapLinks.map(item => (
              <SitemapSubItem key={item.text} data={item} />
            ))}
          </>
        ) : null}
      </Col>
    </>
  );
};
